import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M5.25 7.00001V11H3.75V7.00001H5.25Z" fill="currentColor" />
    <path d="M12.25 7.00001H10.75V11H12.25V7.00001Z" fill="currentColor" />
    <path d="M10 9.00001V11H8.5V9.00001H10Z" fill="currentColor" />
    <path d="M7.75 11V6.00001H6.25V11H7.75Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="M3.93245 3.14837C6.4437 2.97008 9.55632 2.97008 12.0676 3.14837C13.293 3.23537 14.2669 4.154 14.4852 5.33413C14.8602 7.3619 15.1008 8.96409 15.1991 10.6739C15.2816 12.1075 14.1896 13.311 12.7668 13.3934C9.97205 13.5551 6.02794 13.5551 3.23316 13.3934C1.81039 13.311 0.718404 12.1075 0.800866 10.6739C0.899219 8.96409 1.13978 7.36189 1.51484 5.33413C1.73312 4.154 2.707 3.23537 3.93245 3.14837ZM11.9613 4.6446C9.52082 4.47133 6.4792 4.47133 4.03868 4.6446C3.52301 4.68121 3.08901 5.07069 2.98982 5.60695C2.61938 7.60974 2.39149 9.1415 2.29839 10.7601C2.26411 11.356 2.71308 11.8607 3.31981 11.8959C6.05688 12.0542 9.94312 12.0542 12.6802 11.8959C13.2869 11.8607 13.7359 11.356 13.7016 10.7601C13.6085 9.1415 13.3806 7.60974 13.0102 5.60694C12.911 5.07069 12.477 4.68121 11.9613 4.6446Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
